/* Ashisha X assistant widget — chat by default, one-tap voice (Retell).
   Self-contained: everything renders inside a Shadow DOM so the store's
   theme CSS is never touched and never leaks in. */
(function () {
  "use strict";
  if (window.__ashishaBotLoaded) return;
  window.__ashishaBotLoaded = true;

  /* ===== SETTINGS — paste the Retell PUBLIC key between the quotes ===== */
  var CFG = {
    publicKey: "key_726a6ba1b5d1145e801587c0d77e",
    chatAgentId: "agent_ff69361226779178b6d4785265",
    voiceAgentId: "agent_50ab6ecc570002a327bfb3a6ad",
  };
  /* ===================================================================== */
  var API = "https://api.retellai.com";
  function hdrs() { return { "Content-Type": "application/json", Authorization: "Bearer " + CFG.publicKey }; }
  function post(path, body) {
    return fetch(API + path, { method: "POST", headers: hdrs(), body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(path + " " + r.status); return r.json(); });
  }
  function agentText(res) {
    var m = (res && res.messages) || [];
    return m.filter(function (x) { return x && x.role === "agent" && typeof x.content === "string"; })
      .map(function (x) { return x.content; }).join("\n\n").trim();
  }
  var SDK_URLS = [
    "https://cdn.jsdelivr.net/npm/retell-client-js-sdk@3/+esm",
    "https://esm.sh/retell-client-js-sdk@3",
  ];
  var STORE = "ashisha-bot-v1";
  var GREETING = "Hi, welcome to Ashisha X 👋 I can help with our store, the lounge, delivery, returns and wholesale. Ask me anything, or tap the mic to talk.";
  var CHIPS = ["Lounge hours", "Where are you?", "Delivery & free shipping", "Returns policy"];

  /* ---------- state ---------- */
  var state = { open: false, chatId: null, msgs: [], busy: false, voice: null };
  function load() {
    try {
      var s = JSON.parse(sessionStorage.getItem(STORE) || "null");
      if (s && Array.isArray(s.msgs)) { state.chatId = s.chatId || null; state.msgs = s.msgs.slice(-60); }
    } catch (e) {}
  }
  function save() {
    try { sessionStorage.setItem(STORE, JSON.stringify({ chatId: state.chatId, msgs: state.msgs.slice(-60) })); } catch (e) {}
  }

  /* ---------- styles ---------- */
  var CSS = `
:host{all:initial}
*{box-sizing:border-box;margin:0;padding:0}
.root{--lime:#dcf94f;--lime-d:#c4e536;--cyan:#4fc4f9;--ink:#f4f5f7;--mute:rgba(244,245,247,.62);
  --glass:rgba(10,10,12,.92);--blue:#13306e;--blue-hi:#1d4aa8;--chrome:linear-gradient(180deg,#4a4d54 0%,#1b1c20 18%,#0a0a0c 48%,#141518 70%,#2e3036 100%);--glass-hi:rgba(255,255,255,.07);--line:rgba(255,255,255,.12);
  font-family:"Assistant",ui-sans-serif,system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;
  color:var(--ink);font-size:15px;line-height:1.45;-webkit-font-smoothing:antialiased}
button{font:inherit;color:inherit;background:none;border:0;cursor:pointer}
button:focus-visible,input:focus-visible{outline:2px solid #5b8cff;outline-offset:2px}

/* launcher */
.fab{position:fixed;right:22px;bottom:92px;z-index:2147483000;height:54px;padding:0 20px 0 22px;border-radius:999px;
  display:flex;align-items:center;gap:10px;font-size:16px;font-weight:700;letter-spacing:.01em;color:#fff;white-space:nowrap;
  background:var(--chrome);border:1px solid rgba(255,255,255,.22);
  box-shadow:0 12px 30px rgba(0,0,0,.6),inset 0 1px 0 rgba(255,255,255,.45),inset 0 -2px 6px rgba(0,0,0,.6),0 0 0 1px rgba(0,0,0,.6);
  transition:transform .25s cubic-bezier(.2,.8,.2,1),box-shadow .25s}
.fab:hover{transform:translateY(-2px);box-shadow:0 16px 36px rgba(0,0,0,.65),inset 0 1px 0 rgba(255,255,255,.55),inset 0 -2px 6px rgba(0,0,0,.6),0 0 0 1px rgba(30,90,220,.6),0 0 24px rgba(30,90,220,.35)}
.fab .lbl{text-shadow:0 1px 0 rgba(0,0,0,.6)}
.fab .ic{width:32px;height:32px;border-radius:50%;display:grid;place-items:center;
  background:linear-gradient(180deg,#2f6ef0,#0d2f8a);box-shadow:inset 0 1px 0 rgba(255,255,255,.35),0 2px 8px rgba(20,70,200,.45)}
.fab svg{width:18px;height:18px;color:#fff}
.fab .x{display:none}
.root.open .fab .lbl{display:none}.root.open .fab .bubble{display:none}.root.open .fab .x{display:block}
.root.open .fab{padding:0 11px}
.fab::after{content:"";position:absolute;inset:-5px;border-radius:999px;border:1px solid rgba(60,120,255,.45);animation:ring 2.8s ease-out infinite;pointer-events:none}
.root.open .fab::after,.root.seen .fab::after{display:none}
@keyframes ring{0%{transform:scale(.96);opacity:.9}100%{transform:scale(1.12,1.3);opacity:0}}
.cloud{position:fixed;right:22px;bottom:178px;z-index:2147483000;width:268px;padding:16px 16px 14px;border-radius:26px;
  color:#fff;background:linear-gradient(180deg,#2a2c31 0%,#0e0f11 30%,#050506 70%,#17181c 100%);
  border:1px solid rgba(255,255,255,.22);
  box-shadow:0 18px 44px rgba(0,0,0,.6),inset 0 1px 0 rgba(255,255,255,.35),0 0 0 1px rgba(0,0,0,.6),0 0 26px rgba(30,90,220,.28);
  opacity:0;visibility:hidden;transform:translate(40px,30px) scale(.6);transform-origin:bottom right;
  transition:opacity .45s ease,transform .7s cubic-bezier(.18,1.35,.4,1),visibility 0s linear .7s}
.cloud.show{opacity:1;visibility:visible;transform:none;transition:opacity .45s ease,transform .7s cubic-bezier(.18,1.35,.4,1),visibility 0s}
.cloud.show .cin{animation:bob 3.6s ease-in-out .8s infinite}
@keyframes bob{0%,100%{transform:translateY(0)}50%{transform:translateY(-5px)}}
/* cloud puffs + tail */
.cloud::before,.cloud::after{content:"";position:absolute;border-radius:50%;background:#0b0c0e;border:1px solid rgba(255,255,255,.18)}
.cloud::before{width:14px;height:14px;right:40px;bottom:-16px;box-shadow:0 6px 14px rgba(0,0,0,.5)}
.cloud::after{width:7px;height:7px;right:30px;bottom:-27px}
.cloud .cx{position:absolute;top:8px;right:8px;width:26px;height:26px;border-radius:50%;display:grid;place-items:center;color:rgba(244,245,247,.6)}
.cloud .cx:hover{background:rgba(255,255,255,.08);color:#fff}
.cloud .cx svg{width:14px;height:14px}
.cloud .ct{font-size:16px;font-weight:700;line-height:1.3;padding-right:20px}
.cloud .cs{font-size:13.5px;color:rgba(244,245,247,.75);margin-top:4px;line-height:1.4}
.cloud .new{display:inline-block;font-size:10.5px;font-weight:800;letter-spacing:.12em;padding:3px 8px;border-radius:999px;margin-bottom:8px;
  color:#cfdcff;background:rgba(29,74,168,.35);border:1px solid rgba(90,140,255,.5)}
.cloud .ca{display:flex;gap:8px;margin-top:12px}
.cloud .ca button{flex:1;height:40px;border-radius:999px;display:flex;align-items:center;justify-content:center;gap:7px;font-size:14px;font-weight:700}
.cloud .talk{color:#fff;background:linear-gradient(180deg,#2f6ef0,#0d2f8a);box-shadow:inset 0 1px 0 rgba(255,255,255,.35),0 6px 16px rgba(13,47,138,.5)}
.cloud .talk:hover{filter:brightness(1.12)}
.cloud .talk svg{width:16px;height:16px}
.cloud .talk .pulse{position:relative}
.cloud .talk .pulse::after{content:"";position:absolute;inset:-6px;border-radius:50%;border:2px solid rgba(255,255,255,.55);animation:mp 1.8s ease-out infinite}
@keyframes mp{0%{transform:scale(.6);opacity:.9}100%{transform:scale(1.5);opacity:0}}
.cloud .chat{color:#e8ecf5;background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.18)}
.cloud .chat:hover{background:rgba(255,255,255,.13)}
.root.open .cloud{opacity:0;visibility:hidden;pointer-events:none}
.fab .mc{width:32px;height:32px;border-radius:50%;display:grid;place-items:center;margin-left:-4px;
  background:linear-gradient(180deg,#3a3d44,#121316);border:1px solid rgba(255,255,255,.25);box-shadow:inset 0 1px 0 rgba(255,255,255,.3)}
.fab .mc svg{width:16px;height:16px;color:#fff}
.root.open .fab .mc{display:none}

/* panel */
.panel{position:fixed;right:96px;bottom:22px;z-index:2147483001;width:384px;height:min(640px,calc(100vh - 44px));
  border-radius:28px;overflow:hidden;display:flex;flex-direction:column;isolation:isolate;
  background:
    linear-gradient(115deg,transparent 0 30%,rgba(255,255,255,.07) 38%,transparent 46%,transparent 62%,rgba(255,255,255,.04) 68%,transparent 74%),
    linear-gradient(180deg,#26282d 0%,#0e0f11 14%,#050506 50%,#0b0c0e 82%,#1d1f23 100%);
  backdrop-filter:blur(24px) saturate(140%);-webkit-backdrop-filter:blur(24px) saturate(140%);
  border:1px solid rgba(255,255,255,.20);
  box-shadow:0 30px 80px rgba(0,0,0,.75),inset 0 1px 0 rgba(255,255,255,.35),inset 0 -1px 0 rgba(255,255,255,.08),inset 0 0 0 1px rgba(0,0,0,.8);
  opacity:0;transform:translateY(14px) scale(.97);transform-origin:bottom right;pointer-events:none;
  transition:opacity .28s ease,transform .32s cubic-bezier(.2,.8,.2,1)}
.root.open .panel{opacity:1;transform:none;pointer-events:auto}
/* liquid blobs behind the glass */
.blobs{display:none}
.blobs i{position:absolute;border-radius:50%;filter:blur(46px);opacity:.38}
.blobs i:nth-child(1){width:260px;height:260px;background:var(--lime);top:-110px;left:-80px;opacity:.22;animation:f1 16s ease-in-out infinite alternate}
.blobs i:nth-child(2){width:240px;height:240px;background:var(--cyan);bottom:-120px;right:-90px;opacity:.20;animation:f2 19s ease-in-out infinite alternate}
.blobs i:nth-child(3){width:180px;height:180px;background:#7a5cff;top:40%;left:55%;opacity:.12;animation:f1 22s ease-in-out infinite alternate-reverse}
@keyframes f1{to{transform:translate(70px,60px) scale(1.15)}}
@keyframes f2{to{transform:translate(-60px,-80px) scale(1.1)}}
.panel::before{content:"";position:absolute;inset:0;z-index:-1;pointer-events:none;
  background:radial-gradient(120% 40% at 50% -8%,rgba(255,255,255,.14),transparent 60%),radial-gradient(90% 30% at 50% 108%,rgba(255,255,255,.07),transparent 70%)}

.head{display:flex;align-items:center;gap:12px;padding:16px 16px 14px 18px;border-bottom:1px solid rgba(255,255,255,.10);background:linear-gradient(180deg,rgba(255,255,255,.06),rgba(255,255,255,0));box-shadow:0 1px 0 rgba(0,0,0,.8)}
.av{width:38px;height:38px;border-radius:50%;flex:none;position:relative;
  background:conic-gradient(from 0deg,#e9ebef,#5b5f68,#15161a,#9aa0aa,#e9ebef);animation:spin 8s linear infinite;
  box-shadow:0 0 14px rgba(255,255,255,.12)}
.av::after{content:"X";position:absolute;inset:3px;border-radius:50%;background:#0c0c10;display:grid;place-items:center;
  font-weight:700;font-size:15px;color:#fff;letter-spacing:.02em;animation:spin 8s linear infinite reverse}
@keyframes spin{to{transform:rotate(360deg)}}
.ttl{flex:1;min-width:0}
.ttl b{display:block;font-size:16px;font-weight:700;letter-spacing:.01em}
.ttl span{display:flex;align-items:center;gap:6px;font-size:12.5px;color:var(--mute)}
.ttl span::before{content:"";width:7px;height:7px;border-radius:50%;background:#3ddc84;box-shadow:0 0 8px #3ddc84}
.iconbtn{width:36px;height:36px;border-radius:12px;display:grid;place-items:center;color:var(--mute);transition:.2s}
.iconbtn:hover{background:var(--glass-hi);color:var(--ink)}
.iconbtn svg{width:18px;height:18px}

.thread{flex:1;overflow-y:auto;padding:18px 16px 8px;display:flex;flex-direction:column;gap:10px;scroll-behavior:smooth;
  scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.18) transparent}
.thread::-webkit-scrollbar{width:6px}.thread::-webkit-scrollbar-thumb{background:rgba(255,255,255,.16);border-radius:6px}
.msg{max-width:84%;padding:10px 14px;border-radius:18px;white-space:pre-wrap;word-wrap:break-word;animation:pop .28s cubic-bezier(.2,.8,.2,1)}
@keyframes pop{from{opacity:0;transform:translateY(6px)}}
.msg.agent{align-self:flex-start;border-bottom-left-radius:6px;background:#000;border:1px solid rgba(255,255,255,.14);
  box-shadow:inset 0 1px 0 rgba(255,255,255,.10),0 4px 14px rgba(0,0,0,.5)}
.msg.user{align-self:flex-end;border-bottom-right-radius:6px;color:#fff;font-weight:600;
  background:linear-gradient(180deg,var(--blue-hi),var(--blue));border:1px solid rgba(120,160,255,.28);
  box-shadow:inset 0 1px 0 rgba(255,255,255,.18),0 6px 18px rgba(10,40,120,.45)}
.msg.voice::before{content:"🎙 ";opacity:.7}
.msg a{color:#8fb0ff;text-decoration:underline;text-underline-offset:2px}
.msg.user a{color:#fff}
.msg ul{padding-left:18px;margin:4px 0}
.typing{align-self:flex-start;display:flex;gap:4px;padding:12px 14px;border-radius:18px;border-bottom-left-radius:6px;background:#000;border:1px solid rgba(255,255,255,.14)}
.typing i{width:7px;height:7px;border-radius:50%;background:var(--mute);animation:b 1.2s infinite}
.typing i:nth-child(2){animation-delay:.15s}.typing i:nth-child(3){animation-delay:.3s}
@keyframes b{0%,60%,100%{transform:none;opacity:.5}30%{transform:translateY(-4px);opacity:1}}

.chips{display:flex;flex-wrap:wrap;gap:8px;padding:2px 16px 10px}
.chip{padding:7px 12px;border-radius:999px;font-size:13px;border:1px solid rgba(90,140,255,.45);color:#cfdcff;
  background:rgba(29,74,168,.22);transition:.2s}
.chip:hover{background:rgba(29,74,168,.45)}

.comp{display:flex;align-items:center;gap:8px;margin:6px 12px 8px;padding:6px 6px 6px 16px;border-radius:999px;
  background:#000;border:1px solid rgba(255,255,255,.16);box-shadow:inset 0 2px 6px rgba(0,0,0,.8),0 1px 0 rgba(255,255,255,.06)}
.comp:focus-within{border-color:rgba(90,140,255,.6)}
.comp input{flex:1;min-width:0;background:none;border:0;outline:0;color:var(--ink);font:inherit;font-size:15px;padding:8px 0}
.comp input::placeholder{color:rgba(244,245,247,.42)}
.send,.mic{width:40px;height:40px;border-radius:50%;display:grid;place-items:center;flex:none;transition:.2s}
.send{color:var(--mute)}.send:not(:disabled):hover{color:var(--ink);background:var(--glass-hi)}.send:disabled{opacity:.35;cursor:default}
.mic{background:linear-gradient(180deg,#2f6ef0,#0d2f8a);color:#fff;box-shadow:inset 0 1px 0 rgba(255,255,255,.35),0 0 0 4px rgba(29,74,168,.25),0 6px 16px rgba(13,47,138,.5)}
.mic:hover{transform:scale(1.05);filter:brightness(1.12)}
.send svg,.mic svg{width:19px;height:19px}
.foot{text-align:center;font-size:11px;color:rgba(244,245,247,.38);padding:0 12px 10px}

/* voice mode */
.voice{position:absolute;inset:0;z-index:5;display:flex;flex-direction:column;align-items:center;
  background:radial-gradient(120% 60% at 50% 30%,#14161b,#030304 75%);backdrop-filter:blur(30px) saturate(160%);-webkit-backdrop-filter:blur(24px) saturate(160%);
  opacity:0;pointer-events:none;transition:opacity .3s}
.root.calling .voice{opacity:1;pointer-events:auto}
.voice .vhead{align-self:stretch;display:flex;justify-content:flex-end;padding:14px}
.orbwrap{flex:1;display:grid;place-items:center;width:100%}
.orb{--lvl:0;width:170px;height:170px;border-radius:50%;position:relative;
  transform:scale(calc(1 + var(--lvl) * .22));transition:transform .09s linear}
.orb::before{content:"";position:absolute;inset:-26px;border-radius:50%;
  background:radial-gradient(circle,rgba(47,110,240,calc(.22 + var(--lvl)*.55)),transparent 65%);filter:blur(8px)}
.orb::after{content:"";position:absolute;inset:0;border-radius:50%;
  background:radial-gradient(circle at 35% 30%,rgba(255,255,255,.75),rgba(255,255,255,0) 26%),
    conic-gradient(from 0deg,#e9ebef,#2f6ef0,#0a0a0c,#9aa0aa,#1d4aa8,#e9ebef);
  animation:spin 6s linear infinite;box-shadow:inset 0 -20px 40px rgba(0,0,0,.55),0 0 60px rgba(47,110,240,.35);
  -webkit-mask:radial-gradient(circle,#000 62%,rgba(0,0,0,.92) 70%,#000 71%);mask:radial-gradient(circle,#000 62%,rgba(0,0,0,.92) 70%,#000 71%)}
.root.connecting .orb::after{animation-duration:1.6s;opacity:.7}
.vstatus{font-size:13px;letter-spacing:.14em;text-transform:uppercase;color:#8fb0ff;margin-top:6px}
.caption{min-height:66px;max-width:86%;text-align:center;color:var(--ink);font-size:16px;margin:14px auto 0;
  display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}
.vctrl{display:flex;gap:18px;padding:22px 0 28px}
.vbtn{width:58px;height:58px;border-radius:50%;display:grid;place-items:center;border:1px solid rgba(255,255,255,.16);
  background:rgba(255,255,255,.08);backdrop-filter:blur(10px);transition:.2s}
.vbtn:hover{background:rgba(255,255,255,.14)}
.vbtn svg{width:22px;height:22px}
.vbtn.end{background:#ff4d5e;border-color:transparent;box-shadow:0 8px 22px rgba(255,77,94,.35)}
.vbtn.end:hover{background:#ff3347}
.vbtn.muted{background:#1d4aa8;color:#fff}

@media (max-width:520px){
  .panel{right:0;left:0;bottom:0;width:100%;height:min(88vh,100dvh);border-radius:26px 26px 0 0;transform-origin:bottom center}
  .root.open .fab{display:none}
  .fab{right:14px;bottom:84px;height:50px;font-size:15px}
  .cloud{right:14px;bottom:166px;width:min(268px,calc(100vw - 28px))}
}
@media (prefers-reduced-motion:reduce){*,*::before,*::after{animation:none!important;transition:none!important}}
`;

  var I = {
    bubble: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a8.5 8.5 0 0 1-12.6 7.4L3 21l1.6-5.2A8.5 8.5 0 1 1 21 12z"/><path d="M8.5 12h.01M12 12h.01M15.5 12h.01" stroke-width="2.6"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    send: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    mic: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3"/></svg>',
    micOff: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3l18 18M9 9v2a3 3 0 0 0 5.1 2.1M15 9.3V6a3 3 0 0 0-5.7-1.3M5 11a7 7 0 0 0 11.6 5.3M19 11a7 7 0 0 1-.6 2.8M12 18v3"/></svg>',
    hang: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 9c-3.3 0-6.3 1-8.6 2.7-.6.5-.7 1.3-.2 1.9l1.6 2c.4.5 1.2.7 1.8.3l2.3-1.4c.4-.3.7-.8.6-1.3l-.2-1.6c1.7-.5 3.7-.5 5.4 0l-.2 1.6c-.1.5.2 1 .6 1.3l2.3 1.4c.6.4 1.4.2 1.8-.3l1.6-2c.5-.6.4-1.4-.2-1.9C18.3 10 15.3 9 12 9z"/></svg>',
    reset: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>',
    min: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg>',
  };

  /* ---------- DOM ---------- */
  var host = document.createElement("div");
  host.id = "ashisha-x-assistant";
  host.style.cssText = "position:static!important;all:initial";
  var root = host.attachShadow({ mode: "open" });
  root.innerHTML =
    "<style>" + CSS + "</style>" +
    '<div class="root">' +
      '<div class="cloud" role="dialog" aria-label="Chat or talk to Ashisha X"><div class="cin">' +
        '<button class="cx" type="button" aria-label="Dismiss">' + I.x + '</button>' +
        '<span class="new">NEW \u00b7 VOICE</span>' +
        '<div class="ct">Want to chat? \ud83d\udc4b</div>' +
        '<div class="cs">Try our new voice assistant. Just tap and talk, or type if you prefer.</div>' +
        '<div class="ca"><button class="talk" type="button"><span class="pulse">' + I.mic + '</span>Talk now</button>' +
        '<button class="chat" type="button">Chat</button></div>' +
      '</div></div>' +
      '<button class="fab" aria-label="Open Ashisha X assistant"><span class="lbl">Want to chat?</span><span class="ic"><span class="bubble">' + I.bubble + '</span><span class="x">' + I.x + "</span></span><span class=\"mc\" aria-hidden=\"true\">" + I.mic + "</span></button>" +
      '<section class="panel" role="dialog" aria-label="Ashisha X assistant">' +
        '<div class="blobs"><i></i><i></i><i></i></div>' +
        '<header class="head"><div class="av" aria-hidden="true"></div><div class="ttl"><b>Ashisha X</b><span>AI assistant · online</span></div>' +
          '<button class="iconbtn reset" aria-label="New conversation" title="New conversation">' + I.reset + "</button>" +
          '<button class="iconbtn close" aria-label="Minimise">' + I.min + "</button></header>" +
        '<div class="thread" aria-live="polite"></div>' +
        '<div class="chips"></div>' +
        '<form class="comp"><input type="text" maxlength="600" placeholder="Ask about the store or lounge…" aria-label="Message">' +
          '<button class="send" type="submit" aria-label="Send" disabled>' + I.send + "</button>" +
          '<button class="mic" type="button" aria-label="Talk to the assistant" title="Talk to us">' + I.mic + "</button></form>" +
        '<div class="foot">AI assistant · answers may not be perfect · 18+ only</div>' +
        '<div class="voice" aria-label="Voice call">' +
          '<div class="vhead"><button class="iconbtn vmin" aria-label="Minimise">' + I.min + "</button></div>" +
          '<div class="orbwrap"><div><div class="orb"></div></div></div>' +
          '<div class="vstatus">Connecting…</div>' +
          '<div class="caption"></div>' +
          '<div class="vctrl"><button class="vbtn mute" aria-label="Mute">' + I.mic + '</button><button class="vbtn end" aria-label="End call">' + I.hang + "</button></div>" +
        "</div>" +
      "</section>" +
    "</div>";

  var $ = function (s) { return root.querySelector(s); };
  var R = $(".root"), thread = $(".thread"), chips = $(".chips"), form = $(".comp"), input = $(".comp input"),
      sendBtn = $(".send"), micBtn = $(".mic"), orb = $(".orb"), vstatus = $(".vstatus"), caption = $(".caption"),
      muteBtn = $(".vbtn.mute"), cloud = $(".cloud");

  /* ---------- rendering ---------- */
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function fmt(text) {
    var h = esc(text);
    h = h.replace(/\*\*(.+?)\*\*/g, "<b>$1</b>");
    h = h.replace(/(https?:\/\/[^\s<]+[^\s<.,;:!?)])/g, '<a href="$1" target="_blank" rel="noopener">$1</a>');
    h = h.replace(/(^|[\s(])((?:www\.)?ashishaonline\.co\.za(?:\/[^\s<]*[^\s<.,;:!?)])?)/g, function (m, p, u) {
      return p + '<a href="https://' + u.replace(/^https?:\/\//, "") + '" target="_blank" rel="noopener">' + u + "</a>";
    });
    h = h.replace(/(^|\s)([\w.+-]+@[\w-]+\.[\w.]+)/g, '$1<a href="mailto:$2">$2</a>');
    return h;
  }
  function bubble(m) {
    var d = document.createElement("div");
    d.className = "msg " + m.role + (m.voice ? " voice" : "");
    d.innerHTML = fmt(m.text);
    return d;
  }
  function render() {
    thread.innerHTML = "";
    thread.appendChild(bubble({ role: "agent", text: GREETING }));
    state.msgs.forEach(function (m) { thread.appendChild(bubble(m)); });
    chips.style.display = state.msgs.length ? "none" : "";
    scroll();
  }
  function scroll() { requestAnimationFrame(function () { thread.scrollTop = thread.scrollHeight; }); }
  function add(role, text, extra) {
    var m = { role: role, text: text };
    if (extra) for (var k in extra) m[k] = extra[k];
    state.msgs.push(m); save();
    thread.appendChild(bubble(m)); chips.style.display = "none"; scroll();
    return m;
  }
  CHIPS.forEach(function (c) {
    var b = document.createElement("button");
    b.type = "button"; b.className = "chip"; b.textContent = c;
    b.onclick = function () { send(c); };
    chips.appendChild(b);
  });

  /* ---------- chat ---------- */
  var typingEl = null;
  function typing(on) {
    if (on && !typingEl) { typingEl = document.createElement("div"); typingEl.className = "typing"; typingEl.innerHTML = "<i></i><i></i><i></i>"; thread.appendChild(typingEl); scroll(); }
    if (!on && typingEl) { typingEl.remove(); typingEl = null; }
  }
  function send(text) {
    text = (text || "").trim();
    if (!text || state.busy) return;
    add("user", text);
    input.value = ""; sendBtn.disabled = true;
    state.busy = true; typing(true);
    function newChat() { return post("/create-chat", { agent_id: CFG.chatAgentId }).then(function (c) { state.chatId = c.chat_id; return c.chat_id; }); }
    function complete(id) { return post("/create-chat-completion", { chat_id: id, content: text }); }
    (state.chatId ? complete(state.chatId).catch(function () { return newChat().then(complete); }) : newChat().then(complete))
      .then(function (res) {
        save();
        add("agent", agentText(res) || "Sorry, I didn't catch that. Could you rephrase?");
      })
      .catch(function () { add("agent", "I can't connect right now. Please WhatsApp us on 060 364 3130 or email info@ashisha.co.za."); })
      .then(function () { state.busy = false; typing(false); input.focus(); });
  }
  form.addEventListener("submit", function (e) { e.preventDefault(); send(input.value); });
  input.addEventListener("input", function () { sendBtn.disabled = !input.value.trim(); });

  /* ---------- voice (Retell web call, public key) ---------- */
  var sdkPromise = null;
  function loadSdk() {
    if (sdkPromise) return sdkPromise;
    var i = 0;
    // Load the SDK through a <script type="module"> tag. A literal dynamic import here
    // gets rewritten by Shopify's asset pipeline into require(), which breaks in browsers.
    function importModule(url) {
      return new Promise(function (resolve, reject) {
        var key = "__ashishaSdk" + Date.now() + Math.floor(Math.random() * 1e6);
        var done = false;
        window.addEventListener(key, function () { done = true; resolve(window[key]); }, { once: true });
        var tag = document.createElement("script");
        tag.type = "module";
        tag.textContent = "import * as m from " + JSON.stringify(url) + "; window[" + JSON.stringify(key) + "] = m; window.dispatchEvent(new Event(" + JSON.stringify(key) + "));";
        document.head.appendChild(tag);
        setTimeout(function () { if (!done) reject(new Error("SDK load timeout")); }, 15000);
      });
    }
    function attempt() {
      return importModule(SDK_URLS[i]).catch(function (e) { i++; if (i < SDK_URLS.length) return attempt(); throw e; });
    }
    sdkPromise = attempt().catch(function (e) { sdkPromise = null; throw e; });
    return sdkPromise;
  }
  var client = null, call = null, voiceItems = {}, rafLevel = 0;

  function setStatus(t) { vstatus.textContent = t; }
  function endUi() {
    R.classList.remove("calling", "connecting");
    orb.style.setProperty("--lvl", 0);
    caption.textContent = "";
    muteBtn.classList.remove("muted"); muteBtn.innerHTML = I.mic;
    call = null;
  }
  function onTranscript(items) {
    if (!Array.isArray(items)) return;
    items.forEach(function (it) {
      if (!it || (it.role !== "agent" && it.role !== "user") || !it.content) return;
      var key = it.id || it.role + "_" + it.time_sec;
      var m = voiceItems[key];
      if (!m) { m = voiceItems[key] = add(it.role, it.content, { voice: true }); m.el = thread.lastChild; }
      else if (m.text !== it.content) { m.text = it.content; if (m.el) m.el.innerHTML = fmt(it.content); save(); }
      if (it.role === "agent") caption.textContent = it.content;
    });
    scroll();
  }
  function onAudio(samples) {
    if (!samples || !samples.length) return;
    var sum = 0;
    for (var i = 0; i < samples.length; i++) sum += samples[i] * samples[i];
    var rms = Math.min(1, Math.sqrt(sum / samples.length) * 4);
    rafLevel = rafLevel * 0.6 + rms * 0.4;
    orb.style.setProperty("--lvl", rafLevel.toFixed(3));
  }
  function startVoice() {
    if (call) return;
    if (!CFG.publicKey || !CFG.voiceAgentId) { add("agent", "Voice isn't available right now — please type your question instead."); return; }
    R.classList.add("calling", "connecting");
    setStatus("Connecting…"); caption.textContent = "";
    voiceItems = {};
    loadSdk().then(function (mod) {
      var RetellClient = mod.RetellClient || (mod.default && mod.default.RetellClient);
      if (!RetellClient) throw new Error("Retell SDK not found");
      client = client || new RetellClient({ key: CFG.publicKey });
      call = client.createWebCall({
        agent_id: CFG.voiceAgentId,
        transcript: true,
        audio: { emitRawAudioSamples: true },
        metadata: { source: "ashishaonline.co.za", page: location.pathname },
        hooks: {
          onStatus: function (s) {
            if (s === "live") { R.classList.remove("connecting"); setStatus("Listening"); try { call && call.startAudioPlayback && call.startAudioPlayback(); } catch (e) {} }
            if (s === "ended") endUi();
          },
          onEnd: function () { endUi(); },
          onError: function (err) {
            var msg = (err && err.message) || "";
            endUi();
            add("agent", /permission|denied|NotAllowed/i.test(msg)
              ? "I need microphone access to talk. Please allow the mic in your browser and tap the mic again — or just type here."
              : "Sorry, I couldn't start the voice call. You can type your question here instead.");
          },
          onTranscript: function (t) { onTranscript(t); },
          onAudio: function (s) { onAudio(s); },
        },
      });
    }).catch(function () {
      endUi();
      add("agent", "Sorry, voice couldn't load on this device. You can type your question here instead.");
    });
  }
  function stopVoice() { try { call && call.end && call.end(); } catch (e) {} endUi(); }
  micBtn.addEventListener("click", startVoice);
  micBtn.addEventListener("pointerenter", function () { loadSdk().catch(function () {}); }, { once: true });
  $(".vbtn.end").addEventListener("click", stopVoice);
  muteBtn.addEventListener("click", function () {
    if (!call) return;
    var muted = muteBtn.classList.toggle("muted");
    try { muted ? call.mute() : call.unmute(); } catch (e) {}
    muteBtn.innerHTML = muted ? I.micOff : I.mic;
    setStatus(muted ? "Muted" : "Listening");
  });

  /* ---------- open / close ---------- */
  function setOpen(o) {
    state.open = o;
    R.classList.toggle("open", o);
    $(".fab").setAttribute("aria-label", o ? "Close Ashisha X assistant" : "Open Ashisha X assistant");
    if (o) {
      if (cloud.classList.contains("show")) hideCloud();
      R.classList.add("seen");
      try { localStorage.setItem(STORE + "-seen", "1"); } catch (e) {}
      setTimeout(function () { if (window.matchMedia("(min-width:521px)").matches) input.focus(); }, 250);
      loadSdk().catch(function () {});
    }
  }
  $(".fab").addEventListener("click", function () { setOpen(!state.open); });
  $(".close").addEventListener("click", function () { setOpen(false); });
  $(".vmin").addEventListener("click", function () { setOpen(false); });
  $(".reset").addEventListener("click", function () {
    state.chatId = null; state.msgs = []; save(); render();
  });
  root.addEventListener("keydown", function (e) { if (e.key === "Escape" && state.open && !call) setOpen(false); });

  function hideCloud() {
    cloud.classList.remove("show");
    try { sessionStorage.setItem(STORE + "-cloud", "1"); } catch (e) {}
  }
  $(".cloud .cx").addEventListener("click", hideCloud);
  $(".cloud .chat").addEventListener("click", function () { hideCloud(); setOpen(true); });
  $(".cloud .talk").addEventListener("click", function () { hideCloud(); setOpen(true); startVoice(); });

  /* ---------- boot ---------- */
  function boot() {
    load(); render();
    document.body.appendChild(host);
    var seen = false;
    try { seen = localStorage.getItem(STORE + "-seen") === "1"; } catch (e) {}
    if (seen) R.classList.add("seen");
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(STORE + "-cloud") === "1"; } catch (e) {}
    if (!dismissed && !state.open) setTimeout(function () { if (!state.open) cloud.classList.add("show"); }, 2500);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
